import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { filter, Observable, Subscription, take } from "rxjs";
import { LocationDTO } from "../../../../models/LocationDTO";
import { LocationsService } from "../../../../services/Locations.service";
import { GeoClustersFrecuencyPlacesService } from "../../../../services/GeoClustersFrecuencyPlaces.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { MapHelperService } from "src/services/map-helper.service";
import { PanelLocationsService } from "../../../../services/Panel-Locations.service";
import { ToolCarsSelectorService } from "../../../../../../../pages/maps/services/Tool-Cars-Selector.service";
import { PanelInternalLayerService } from "../../../../services/Panel-Internal-Layer.service";
import { CallBackService } from "src/app/features/pages/callback/services/CallBack.service";
import { PopupDetailGeoposService } from "src/app/features/map-features/sections/route-section/services/Popup-Detail-Geopos.service";
import { TutorialService } from "src/app/features/ui/organisms/tutorial/services/tutorial.service";
import { SignalUser } from "src/app/features/shared/models/SignalUser/SignalUser";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { SignalRService } from "src/app/features/shared/services/Signal-R.service";
import { LayerService } from "../../../../services/Layers.service";
import { LocationsMapService } from "../../../../services/LocationsMap.service";
import { environment } from "src/environments/environment";
import { BaseMapService } from "src/app/features/pages/maps/services/BaseMap.service";
import { ValetParkingMapService } from "../../../../services/ValetParkingMap.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { AllowedDTO } from "src/app/features/pages/maps/utils/models/allowedDTO";
import { PanelDetailLocationsService } from "../../../../services/Panel-Detail-Locations.service";
import { NavHeaderService } from "src/app/features/ui/organisms/header/service/nav-header.service";
@Component({
  selector: "locations-ticket-section",
  templateUrl: "./locations-ticket-section.component.html",
  styleUrls: ["./locations-ticket-section.component.css"]
})
export class LocationsTicketMapComponent implements OnInit, OnDestroy {
  
  public $isBuildingMap: Observable<boolean>;
  public _isVisibleDetails: boolean;
  public _isVisiblePanelLocations: boolean;
  public _isVisiblePinbar: boolean;
  public $isVisibleDetails: Observable<boolean>;
  public _baseMap: string = "day";
  public _baseMapText: string = "Modo Nocturno";
  public _UpdateBtnText: string = "Tiempo Real";
  public _IsAuthorized: boolean = false;
  public _isVisibleNavBar: boolean;

  public recargarHora: number = 0;
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";

  PinSelected: LocationDTO;
  $DataGeoJson: Observable<any> = new Observable<any>();
  IsAuthenticated: boolean;
  isLoadingPanel: boolean;
  private _isVisiblePanelLayers: boolean;
  signalUser: SignalUser = new SignalUser();
  isPaintingMap = false;

  

  loadingTimeOut: any;
  public isLoading: boolean = true;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  isVisiblePanel: boolean;
  $isVisiblePanel: Observable<boolean> = new Observable<boolean>();

  private Empty_GeoJson: any = {
    type: "FeatureCollection",
    features: [],
  };
  IdInterval: any;
  subscriber: any;

  subscription_GetLoading: Subscription;
  subscription_OnFocusPin: Subscription;
  subscription_IsVisibleDetails: Subscription;
  subscription_CheckAuthentication: Subscription;
  subscription_GetAPIVersion: Subscription;
  subscription_SetLocationsGeoJSON: Subscription;
  subscription_GetByIdentifier: Subscription;
  Suscription_getOnUpdate: Subscription;
  Subscription_GetBlockingState: Subscription;
  Subscription_GetMapMainSource: Subscription;
  Subscription_isVisiblePanel: Subscription;

  isAdmin: boolean;
  isMapUnified: boolean;
  subscription_dataGeojson: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private locationsService: LocationsService,
    public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    public locationsMapService: LocationsMapService,
    private popupDetailGeoposService: PopupDetailGeoposService,
    private sessionService: SessionService,
    private callbackService: CallBackService,
    private mapHelperService: MapHelperService,
    public panelLocationsService: PanelLocationsService,
    public toolCarSelectorService: ToolCarsSelectorService,
    private changeDetectorRef: ChangeDetectorRef,
    private valetParkingMapService: ValetParkingMapService,
    media: MediaMatcher,
    private tutorialService: TutorialService,
    public layerService: LayerService,
    private panelDetailsService: PanelDetailLocationsService,
    private navHeaderService: NavHeaderService,
    private localStorageService: LocalStorageService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this._isVisiblePinbar = true;
    this._isVisiblePanelLayers = false;

    this.$isVisiblePanel = this.panelLocationsService.getVisibilityPanel();
    this.Subscription_isVisiblePanel = this.$isVisiblePanel.subscribe((element) => {
      this.isVisiblePanel = element;
      setTimeout(() => {
        if (this.isVisiblePanel != undefined && this.isVisiblePanel == true) {
          this.tutorialService.startTutorial(["panelLocationTutorial"]);
        }
      }, 1000);
    });

    this.subscription_GetLoading = this.locationsService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;

      if(this.isLoading){
        if (this.loadingTimeOut)
          clearTimeout(this.loadingTimeOut);

        this.loadingTimeOut = setTimeout(() => {
          this.locationsService.setLoading(false);
        }, 10000);
      }else{
        if (this.loadingTimeOut)
          clearTimeout(this.loadingTimeOut);
      }
    });
    this.locationsService.setLoading(true);

    this.$isVisibleDetails = this.popupDetailGeoposService.checkVisibilityPopup();
    this.subscription_IsVisibleDetails = this.$isVisibleDetails.subscribe(
      (data) => {
        this._isVisibleDetails = data;
      }
    );
  }

  
  async ngOnInit(): Promise<void> {
    await this.callbackService.isNeededCallback();
    this.StartMap();
    this.CheckingSourceURL();
  }

  ngAfterViewInit(): void {
  }


  ngOnDestroy() {
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_OnFocusPin)
      this.subscription_OnFocusPin.unsubscribe();
    if (this.subscription_IsVisibleDetails)
      this.subscription_IsVisibleDetails.unsubscribe();
    if (this.subscription_GetAPIVersion)
      this.subscription_GetAPIVersion.unsubscribe();
    if (this.subscription_GetByIdentifier)
      this.subscription_GetByIdentifier.unsubscribe();
    if (this.Suscription_getOnUpdate)
      this.Suscription_getOnUpdate.unsubscribe();
    if (this.Subscription_GetBlockingState)
      this.Subscription_GetBlockingState.unsubscribe();
    if (this.subscription_dataGeojson)
      this.subscription_dataGeojson.unsubscribe();
    if (this.Subscription_GetMapMainSource)
      this.Subscription_GetMapMainSource.unsubscribe();
    if (this.Subscription_isVisiblePanel)
      this.Subscription_isVisiblePanel.unsubscribe();

    
    this.mobileQuery.removeListener(this._mobileQueryListener);
    // this.locationsService.resetGeoJsonData();
    this.panelLocationsService.tabCategoryFiltersSelected.next({filters: [], categoryToBeAffected: null});
  }

  checkAPI(): any {
    this.subscription_GetAPIVersion = this.sessionService
      .getAPIversion()
      .subscribe(
        (data) => {
          if (data != null) return true;
        },
        (error) => {
          //Error callback
          console.error("error caught in component");
          return false;
        }
      );
  }

  CheckingSourceURL() {
    this.sessionService.CheckURLSource();
    this._isVisibleNavBar = this.sessionService.isMapix;
  }


  StopRecalculateCoords() {
    clearInterval(this.IdInterval);
  }
  
  onPinBarClicked($event: any) {
    if(!environment.production) console.log("evento pin");
    if(!environment.production) console.log($event);
    if ($event == "locations")
      this._isVisiblePanelLocations = !this._isVisiblePanelLocations;
    if ($event == "layers")
      this._isVisiblePanelLayers = !this._isVisiblePanelLayers;
  }

  StartMap() {
    this._isVisiblePinbar = true;
    this.isLoading = false;
    if(!environment.production) console.log(
      "*****************************************START locations MAP *************************************"
    );

    this.locationsService.setLoading(true);
    setTimeout(() => {
      this.locationsService.setLoading(false);
    }, 30000);

    this.Subscription_GetMapMainSource = this.mapHelperService.mainSource$.pipe(
                filter(map => map && map.isMainSourceReady && map.isStyleReady), take(1) ).subscribe(async map => {
      if (map && map.isMainSourceReady && map.isStyleReady && !this.isPaintingMap ) {
        this.locationsMapService.LoadMapLocations();
        this.valetParkingMapService.LoadMapValetParking();
  
        this.locationsService.setLoading(false);

        const params = JSON.parse(this.localStorageService.getQueryParams() || "{}");
        const identifier = params['identifier'] ? params['identifier'] : null;
        if(identifier){
          const newParams = { ...params };
          delete newParams['identifier'];
          this.localStorageService.setQueryParams(JSON.stringify(newParams));
          this.panelDetailsService.canClosePanel$.next(false);
          this.onFocusPin({identifier: identifier});
        }else{
          this.navHeaderService.CheckMapPaneles("locationsMap");
        }
        this.mapHelperService.mapResize();
      }
    });
  }

  onFocusPin(location: any) {
    this.locationsMapService.onFocusPin(location.identifier);
  }

  

}
